<div class="confirmation-popup" *ngIf="dialog" 
     role="dialog" 
     aria-labelledby="confirmation-title" 
     aria-modal="true"
     (click)="onCancel()">
    <div class="confirmation-dialog" (click)="$event.stopPropagation()">
        <div class="confirmation-header" [ngClass]="'header-' + (dialog.type || 'info')">
            <h4 id="confirmation-title">
                <span *ngIf="dialog.type === 'warning'" class="dialog-icon material-icons">
                    warning_amber
                </span>
                <span *ngIf="!dialog.type || dialog.type === 'info'" class="dialog-icon material-icons">
                    help_outline
                </span>
                {{ dialog.title }}
            </h4>
        </div>
        <div class="confirmation-body">
            <p [innerHTML]="sanitizedMessage"></p>
            <p class="warning-text" *ngIf="dialog.warningText">{{ dialog.warningText }}</p>
        </div>
        <div class="confirmation-buttons">
            <button class="cancel-btn" (click)="onCancel()" autofocus>
                {{ dialog.cancelText || 'Cancel' }}
            </button>
            <button [ngClass]="getConfirmButtonClass()" (click)="onConfirm()">
                {{ dialog.confirmText || 'Confirm' }}
            </button>
        </div>
    </div>
</div>
